import { useState } from 'react'
import type { LunarReceiptDto } from '@lunary/api-client'
import { Modal } from '@lunary/ui-web/modal'
import { formatNumber } from '../../shared/ui/charts/scale'
import fieldStyles from '../../shared/ui/confirm-dialog.module.css'

type Props = {
  readonly receipt: LunarReceiptDto | null
  readonly pending: boolean
  readonly error: string | null
  readonly onSubmit: (url: string) => void
  readonly onClose: () => void
}

export function ReceiptIssueDialog({ receipt, pending, error, onSubmit, onClose }: Props) {
  const [url, setUrl] = useState('')
  const [current, setCurrent] = useState<string | null>(null)
  if ((receipt?.id ?? null) !== current) {
    setCurrent(receipt?.id ?? null)
    setUrl(receipt?.receipt_url ?? '')
  }
  const valid = /^https:\/\/\S+$/.test(url.trim())

  return (
    <Modal
      open={receipt !== null}
      size="sm"
      title="Ссылка на чек"
      description={receipt ? `${receipt.service_name} · ${formatNumber(receipt.amount)} ₽. Покупатель увидит ссылку в истории лунаров.` : undefined}
      dismissible={!pending}
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault()
        if (valid && !pending) onSubmit(url.trim())
      }}
      footer={
        <>
          <button type="button" className="secondary" disabled={pending} onClick={onClose}>
            Отмена
          </button>
          <button type="submit" disabled={pending || !valid}>
            {pending ? 'Минуту…' : 'Сохранить'}
          </button>
        </>
      }
    >
      <label className={fieldStyles.field}>
        <span className="muted">Ссылка из «Мой налог» (кнопка «Поделиться» у чека)</span>
        <input type="url" value={url} autoFocus placeholder="https://lknpd.nalog.ru/api/v1/receipt/…" onChange={(e) => setUrl(e.target.value)} />
      </label>
      {error && (
        <p className="error-box" role="alert">
          {error}
        </p>
      )}
    </Modal>
  )
}
